export abstract class ErrorBase implements Error
{
  private _message: string = undefined;
  private _reference: Array<string> = [];
  protected _name: string = 'Error';
  protected _closeable: boolean = false;

  public title: string;
  public text: string;


  public constructor(message: string|undefined = undefined,
                     reference: Array<string> = [],
                     closeable: boolean = true)
  {
    this._message = message;
    this._reference = reference;
    this._closeable = closeable;
  }

  public get message(): string
  {
    return this._message;
  }

  public set message(message: string)
  {
    this._message = message;
  }

  public get reference(): Array<string>
  {
    return this._reference;
  }

  public set reference(reference: Array<string>)
  {
    this._reference = reference;
  }

  public get name(): string
  {
    return this._name;
  }

  public closeable(): boolean
  {
    return this._closeable;
  }
}
(<any>Object).setPrototypeOf(ErrorBase.prototype, Error.prototype);

export class CriticalError extends ErrorBase
{
  protected _name: string = 'CriticalError';
  private _shouldAlert: boolean;

  public constructor(message: string|undefined = undefined,
                     reference: Array<string> = [],
                     shouldAlert: boolean = true)
  {
    super(message, reference, false);
    this._shouldAlert = shouldAlert;
  }

  public shouldAlert(): boolean
  {
    return this._shouldAlert;
  }
}

export class TrivialError extends ErrorBase
{
  protected _name: string = 'TrivialError';
}
